"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillVersion = void 0;
/**
 * A skill version is a built version of a skill created by a SkillBuildJob
 */
var SkillVersion = /** @class */ (function (_super) {
    __extends(SkillVersion, _super);
    function SkillVersion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "SkillVersion";
        _this.skillRef = function () {
            _this.push(function (_) { return "skillRef"; });
        };
        _this.version = function () {
            _this.push(function (_) { return "version"; });
        };
        _this.created = function () {
            _this.push(function (_) { return "created"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return SkillVersion;
}(Array));
exports.SkillVersion = SkillVersion;
//# sourceMappingURL=SkillVersion.js.map